import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { BaseSearchController } from "../_baseSearchController";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { EventService } from "../../services/event-service";
import { SearchService } from "../../services/search-service";
import { AclService } from "../../services/acl-service";
import { WorkflowService } from "../../services/workflow-service";
import { FinancialService } from "../../services/financial-service";

export class FinancialSearchController extends BaseSearchController<Models.IEntitySearchDoc>{
    static $inject = ["$scope", "$q", "$window", "$location", "$filter", "$timeout", "financialService",
        "localCacheService", "notifyService", "entityService", "aclService", "searchService", "eventService", "workflowService"];

    filterByEntityID: string;
    canCreate: boolean;
    resetting: boolean;
    canCopyFilteredEntity: boolean;
    lockedFilteredEntity: boolean;
    listUrl: string;

    selectedAccountingDocumentIDs: number[];
    selectedAccountingDocumentTitles: string[];

    selectedTemplate: string;
    selectedStatus: string;

    constructor(
        $scope: ng.IScope,
        $q: ng.IQService,
        private $window: ng.IWindowService,
        $location: ng.ILocationService,
        private $filter: ng.IFilterService,
        private $timeout: ng.ITimeoutService,
        private financialService: FinancialService,
        localStorage: LocalCacheService,
        notifyService: NotifyService,
        entityService: EntityService,
        private aclService: AclService,
        private searchService: SearchService, private eventService: EventService, private workflowService: WorkflowService) {

        super($scope, $q, $location, $filter, localStorage, notifyService, entityService, searchService);
        this.onSimpleSearch = () => {
            this.SimpleSearch();
        };
        this.sortField = "last_updated";
        this.sortDir = 1;
        this.canCreate = false;
        this.resetting = false;
        this.canCopyFilteredEntity = false;
        this.lockedFilteredEntity = false;
        this.listUrl = "/~";

        this.notifyService.startProgress();
        this.aclService.loadAcls()
            .then((acls) => {
                this.canCreate = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod7);
            })
            .finally(() => {
                this.notifyService.endProgress();
            });

        $scope.$watch(() => {
            if (this.filterByEntityID == null) {
                return null;
            } else {
                return this.filterByEntityID;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        this.UpdateParentRecordStatus(this.filterByEntityID);
                    });
                }
            });

        this.selectedAccountingDocumentIDs = [];
        this.selectedAccountingDocumentTitles = [];
        $scope.$watch(() => this.selectedItems, (newValue: { [key: string]: boolean }) => {
            this.selectedAccountingDocumentIDs = _(newValue)
                .pairs()
                .filter((el) => el[1] === true)
                .map<number>((el: [string, boolean]) => _.parseInt(el[0].split("|")[0]))
                .valueOf();

            this.selectedAccountingDocumentTitles = _(newValue)
                .pairs()
                .filter((el) => el[1] === true)
                .map<string>((el: [string, boolean]) => el[0].split("|")[1])
                .valueOf();
        }, true);

        $scope.$watchCollection(() => [this.selectedStatus, this.selectedTemplate], (newValue) => {
            if (newValue[0] && newValue[1]) {
                var templateID = parseInt(this.selectedTemplate.split('|')[1]);
                var statusID = parseInt(this.selectedStatus.split('|')[1]);

                this.workflowService.getAvailableWorkflowActions(Consts.CharTypeIDs.invoice, templateID, statusID)
                    .then((res) => {
                        this.workflowActions = _.map(res, (action) => {
                            return {
                                key: action.actionName,
                                value: action.actionID
                            }
                        });
                    });
            } else {
                this.workflowActions = [];
            }
        });
    }

    Init(filterByEntityID: string, listUrl: string) {
        if (!_.isEmpty(filterByEntityID)) {
            this.filterByEntityID = filterByEntityID;
            this.relatedSearch = true;
            var filterCharTypeID = Utils.IdBuilder.splitEntityID(filterByEntityID).charTypeID;

            this.aclService.loadActivityAcls()
                .then((acls) => {
                    switch (filterCharTypeID) {
                        case Consts.CharTypeIDs.user:
                            this.canCopyFilteredEntity = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod2);
                            break;
                        case Consts.CharTypeIDs.property:
                            this.canCopyFilteredEntity = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod1);
                            break;
                    }
                });

            this.entityService.getEntity(filterByEntityID)
                .then((result) => {
                    this.entity = result.record;
                    if (result.charDataCollection != null) {
                        if (result.charDataCollection.status.lockIndicator == 0) {
                            this.lockedFilteredEntity = false;
                        }
                        else {
                            this.lockedFilteredEntity = true;
                        }
                    }
                    this.Validate();
                    this.SimpleSearch();
                    this.initialized = true;
                });

            if (!_.isEmpty(listUrl)) {
                this.listUrl = listUrl;
            }
        }
        else {
            this.initialized = true;
        }
    }

    SimpleSearch(resetPage: boolean = false) {
        this.$timeout(() => {
            if (resetPage) {
                if (this.page > 1) {
                    this.resetting = true;
                    this.page = 1;
                }
            }

            var req: Models.IAdvancedSearchModel = {
                charTypeID: Consts.CharTypeIDs.invoice,
                searchGroups: [],
                keywords: this.keywords,
                template: this.selectedTemplate,
                status: this.selectedStatus,
                rowCount: this.rowCount,
                page: this.page,
                relatedEntityID: this.entity.id,
                sortDir: this.sortDir,
                sortField: this.sortField
            }

            this.searchService.advancedSearch(req)
                .then((res) => {
                    this.itemRows = res.documents;
                    this.numFound = res.numFound;
                    this.pageCount = Math.ceil(res.numFound / this.rowCount);

                    this.templateFacets = res.getTemplateFacets();
                    this.statusFacets = res.getStatusFacets();
                });
        });
        //this.onPushState();
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Contact?") && this.$window.confirm("Are you REALLY SURE you want to delete this Contact?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.filterByEntityID)
                .then(() => {
                    this.$window.location.assign(this.listUrl);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Contact");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    UpdateParentRecordStatus(parentEntityID: string) {
        this.entityService.getEntity(parentEntityID)
            .then((result) => {
                if (result.charDataCollection != null) {
                    if (result.charDataCollection.status.lockIndicator == 0) {
                        this.lockedFilteredEntity = false;
                    }
                    else {
                        this.lockedFilteredEntity = true;
                    }
                }
                this.SimpleSearch();
                this.initialized = true;
            });
    }

    // is a	non-empty workflow action selected
    HasWorkflowAction() {
        return !_.isNaN(_.parseInt(this.selectedAction));
    }

    // execute a workflow task on the selected contacts
    RunWorkflow() {
        // if there	is a selected action and contacts	selected
        if (this.HasWorkflowAction() && this.selectedAccountingDocumentIDs.length > 0) {
            // join	the	titles for a confirmation window
            var titles = this.selectedAccountingDocumentTitles.join(",\n");
            if (this.$window.confirm("Are you sure you want to execute workflow on: \n" + titles)) {
                // execute workflow
                this.notifyService.startProgress(); // start	progress bar
                var promises = [];

                this.workflowService.createBatchID()
                    .then((batchIDResult) => {
                        var charTypeID = Consts.CharTypeIDs.invoice;
                        var actionID = _.parseInt(this.selectedAction);
                        var templateID = _.parseInt(this.selectedTemplate.split('|')[1]);
                        var statusID = _.parseInt(this.selectedStatus.split('|')[1]);

                        this.workflowService.getAvailableWorkflowActions(charTypeID, templateID, statusID)
                            .then((results) => {
                                var actions = results;
                                var processID = _.find(actions, (a) => { return a.actionID == actionID; }).processID;

                                _.each(this.selectedAccountingDocumentIDs, (c) => {
                                    promises.push(this.ExecuteWorkflow(batchIDResult.batchID, charTypeID, c, actionID, processID, statusID));
                                });

                                this.$q.all(promises)
                                    .then(() => {
                                        //Passing in 0 as the recID as this is not needed to process the notifications from a queue.  It really is just for logging.
                                        //To call this method from a loop statement would process a queue multiple times, which results in duplicate emails.
                                        //We only need to call this once when the queue has been fully populated
                                        this.workflowService.sendNotificationsFromQueue(charTypeID, 0, batchIDResult.batchID)
                                            .then((sentResult) => {
                                            }, () => {
                                                this.notifyService.notifyError("There was an error executing your workflow action.");
                                            });
                                    })
                                    .then(() => {
                                        this.notifyService.notifySuccess("Workflow action successful!");
                                    }, () => {
                                        this.notifyService.notifySuccess("Workflow action could not be completed");
                                    })
                                    .finally(() => {
                                        this.selectedItems = {};
                                        this.search = true;
                                        this.notifyService.endProgress();
                                    });
                            });
                    });
            }
        } else {
            this.notifyService.notifyError("Please select a workflow action and select contacts from the search results");
        }
    }

    AllCheckChanged() {
        _.forEach(this.itemRows, (itemRow) => {
            this.selectedItems[itemRow.recordID + "|" + itemRow.title] = this.allChecked;
        });
    }

    ExecuteWorkflow(batchID: string, charTypeID: number, recordID: number, actionID: number, processID: number, statusID: number): ng.IPromise<any> {
        return this.workflowService.addNotificationsToQueue(charTypeID, recordID, actionID, batchID, processID)
            .then((result) => {
                return this.workflowService.runPreProcess(charTypeID, processID, actionID, recordID, statusID)
                    .then(() => {
                        return this.workflowService.workflowUpdateEntityStatus(charTypeID, processID, actionID, recordID, statusID)
                            .then((result) => {
                                if (result.statusID > 0) {
                                    var newStatusID = result.statusID;
                                    return this.workflowService.runPostProcess(charTypeID, processID, actionID, recordID, statusID)
                                        .then(() => {
                                        }, () => {
                                            this.notifyService.notifyError("There was an error executing your workflow action.");
                                        });
                                }
                                else {
                                    this.notifyService.notifyError("There was an error executing your workflow action.");
                                }
                            }, () => {
                                this.notifyService.notifyError("There was an error executing your workflow action.");
                            });
                    }, () => {
                        this.notifyService.notifyError("There was an error executing your workflow action.");
                    });

            }, () => {
                this.notifyService.notifyError("There was an error executing your workflow action.");
            });
    }
}